interface ITravelCoordinate {
    latitude: number | null;
    longitude: number | null;
}

enum ResourceTravelLocationType {
    ResourceAddress = 690970000,
    OrganizationalUnitAddress = 690970001,
    LocationAgnostic = 690970002
}

type TravelSegmentKind = 'startBase' | 'betweenShifts' | 'endBase';
type TravelLabelAlignment = 'start' | 'end';
type TravelMeasureStatus = 'ok' | 'unroutable' | 'error';

interface ITravelMeasureRequestSegment {
    id: string;
    from: {
        latitude: number;
        longitude: number;
    };
    to: {
        latitude: number;
        longitude: number;
    };
}

interface ITravelMeasureRequest {
    segments: ITravelMeasureRequestSegment[];
}

interface ITravelMeasureResultSegment {
    id: string;
    status: TravelMeasureStatus;
    durationSeconds?: number | null;
    distanceMeters?: number | null;
}

interface ITravelMeasureResult {
    segments: ITravelMeasureResultSegment[];
}

interface ITravelSegment {
    id: string;
    resourceId: string;
    from: {
        latitude: number;
        longitude: number;
    };
    to: {
        latitude: number;
        longitude: number;
    };
    windowStart: Date;
    windowEnd: Date;
    travelKind: TravelSegmentKind;
    labelAlign: TravelLabelAlignment;
    anchorShiftIds: string[];
    siteLocationDetails?: {
        id?: string;
        name?: string;
        address?: string;
        latitude?: number | null;
        longitude?: number | null;
    };
}

export { ResourceTravelLocationType };
export type {
    ITravelCoordinate,
    ITravelMeasureRequest,
    ITravelMeasureRequestSegment,
    ITravelMeasureResult,
    ITravelMeasureResultSegment,
    ITravelSegment,
    TravelLabelAlignment,
    TravelMeasureStatus,
    TravelSegmentKind
}
